import { HttpRequestOptions } from "@/common/http";
import { getLang, isSSR } from '../config';
import BaseApi from "./BaseApi";
class Fy2Api extends BaseApi {
    token: string = ''
    ip: string = ''
    constructor() {
        super(isSSR ? 'http://api.fuyintv.local' : '/api')
    }

    preRequest(options: HttpRequestOptions): HttpRequestOptions {
        if (this.token) {
            options.headers = Object.assign({ token: this.token }, options.headers)
        }
        options.headers = Object.assign({ 'X-Forwarded-For': this.ip }, options.headers)
        options.query = Object.assign({}, options.query, { lang: getLang() })
        return options;
    }

    postRequest(response: any, api: string) {
        if (response.code == 0 || response.code == 1) {
            return response.data
        }
        throw new Error(response.msg)
    }

    getChannelHome() {
        return this.get(`/apiv2/channel.pc/index`)
    }

    getChannelMenu() {
        return this.get(`/apiv2/channel.pc/menu`)
    }

    getShortTags() {
        return this.get(`/apiv2/channel.pc/shortVideoTag`)
    }

    getAllChannels() {
        return this.get(`/apiv2/channel.index/all`)
    }

    getChannelDetail(id: number) {
        return this.get(`/apiv2/channel.index/detail`, { id })
    }

    getChannelMovies(channel_id: number, page: number, limit: number) {
        return this.get(`/apiv2/channel.index/movie`, { channel_id, page, limit })
    }

    getChannelShorts(channel_id: number) {
        return this.get(`/apiv2/channel.index/microvideo`, { channel_id })
    }

    getChannelArtists(channel_id: number) {
        return this.get(`/apiv2/channel.index/speaker`, { channel_id })
    }

    getChannelFeeds(channel_id: number) {
        return this.get(`/apiv2/channel.index/yuedu`, { channel_id })
    }

    getChannelComments(item_id: number) {
        return this.get(`/apiv2/extend.comment/lists`, { item_id, mid: 7 })
    }

    likeChannel(channel_id: number) {
        return this.get(`/apiv2/channel.index/likes`, { channel_id })
    }

    channelRequest() {
        return this.get(`/apiv2/channel.setting/index`)
    }

    getLiveComments(item_id: number | string) {
        return this.get(`/apiv2/extend.comment/lists`, { item_id, mid: 4 })
    }

    getSearch(index: string, kw: string, page: number, limit: number) {
        return this.get(`/apiv2/channel.search/query`, { index, kw, page, limit })
    }

    getMyShorts(page: number = 1, limit: number = 999) {
        return this.get(`/api/microvideo.collect/lists`, { page, limit, token: this.token })
    }

    setMyShort(vid: number) {
        return this.post(`/api/microvideo.collect/post`, { vid, token: this.token })
    }

    getShortVideos(page: number, limit: number, kw?: string) {
        return this.get(`/api/microvideo.index/lists`, { page, limit, kw })
    }

    getShortVideo(id: number) {
        return this.get(`/api/microvideo.index/detail`, { id })
    }
}

export default new Fy2Api()
